import React from "react";
import Heading2 from '../components/titles/Heading3';
import SectionContainer from '../components/containers/section-container';
import {Col, Row} from 'react-bootstrap';

const Page404 = ({ location }) => (
  <SectionContainer>
    <Row style={{paddingTop: 200}}>
      <Col md={12}>
        <Heading2 title="404_Page_Not_Found" />
      </Col>
    </Row>
  </SectionContainer>
)


export default Page404


// WEBPACK FOOTER //
// ./src/pages/page-404.js